<!-- 教练评价列表组件 - 展示用户对教练的真实评价 -->
<template>
  <div class="DetailEvaluateList">
    <!-- 标题区域 -->
    <div class="devl-title">
      <div class="devl-title-left">
        <img
          class="devl-title-img"
          src="https://cdnvue.gymcity.com.cn/uploads/25coach-evaluate-icon-xxg"
          alt="评价图标"
        />
        <div class="devl-title-text">为你精选展示真实课后评价</div>
      </div>
      <div class="devl-title-right user-btn" @click="handleTabChange">
        <div class="devl-title-text">{{ curTab == 1 ? '最新' : '默认' }}</div>
        <img
          class="devl-title-img"
          src="https://cdnvue.gymcity.com.cn/uploads/25coach-evaluate-icon-switch"
          alt="评价图标"
        />
      </div>
    </div>

    <!-- 评价列表 -->
    <div class="devl-list">
      <div
        class="devl-item"
        v-for="(item, index) in evaluateList"
        :key="`evaluate-${index}`"
      >
        <!-- 用户信息区域 -->
        <div class="devl-item-user">
          <div class="user-img-box">
            <img
              class="user-img"
              :src="item.image"
              :alt="`${item.truename}头像`"
              @error="handleImageError"
            />
          </div>
          <div class="user-name">{{ item.truename }}</div>
          <div class="user-time" v-if="item.online">
            在线{{ item.online }}天
          </div>
        </div>

        <!-- 评价描述区域 -->
        <div class="devl-item-desc">
          <div class="desc-left">
            <!-- 评分显示 -->
            <div class="desc-score" v-if="getScoreInfo(item.coach_score)">
              <img
                class="score-img"
                :src="getScoreInfo(item.coach_score).img"
                :alt="getScoreInfo(item.coach_score).text"
              />
              <div class="score-text">
                {{ getScoreInfo(item.coach_score).text }}
              </div>
            </div>

            <!-- 分隔线 -->
            <div
              class="desc-line"
              v-if="getScoreInfo(item.coach_score) && item.target"
            ></div>

            <!-- 训练计划-目标 -->
            <div class="desc-target" v-if="item.target">
              {{ item.target }}
            </div>
          </div>

          <!-- 评价日期 -->
          <div class="desc-date">{{ formatDate(item.addtime) }}</div>
        </div>

        <!-- 评价内容 -->
        <div class="devl-item-content">
          <template v-if="item.comment.length > 112 && !showMoreObj[index]">
            {{ item.comment.slice(0, 112) }}...<span
              class="cent-btn"
              @click="handleMore(index)"
              >展开</span
            >
          </template>
          <template v-else>
            {{ item.comment }}
          </template>
        </div>

        <!-- 标签列表 -->
        <div
          class="devl-item-tag"
          v-if="item.tag_list && item.tag_list.length > 0"
        >
          <div
            class="tag-item"
            v-for="(tag, tagIndex) in item.tag_list"
            :key="`tag-${tagIndex}`"
          >
            {{ tag }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailEvaluateList',

  components: {},

  props: {
    // 评价列表数据
    evaluateList: {
      type: Array,
      default: () => [],
      validator: function (value) {
        // 验证数组中的每个元素是否包含必要字段
        return value.every(
          (item) =>
            item && typeof item === 'object' && (item.truename || item.comment)
        )
      }
    }
  },

  data() {
    return {
      // 评分配置对象 - 根据评分值显示对应的图标和文字
      scoreObj: {
        3: {
          img: 'https://cdnvue.gymcity.com.cn/uploads/24evaluation-icon-yb-on',
          text: '一般般'
        },
        5: {
          img: 'https://cdnvue.gymcity.com.cn/uploads/24evaluation-icon-tz-on',
          text: '太赞啦'
        }
      },
      showMoreObj: {},
      curTab: 0 // 0 默认 1 最新
    }
  },

  computed: {
    // 计算是否有评价数据
    hasEvaluateData() {
      return this.evaluateList && this.evaluateList.length > 0
    }
  },

  watch: {},

  created() {},

  mounted() {
    // 组件挂载后的逻辑
  },

  beforeDestroy() {
    // 组件销毁前的清理工作
  },

  methods: {
    handleTabChange() {
      this.curTab = this.curTab == 1 ? 0 : 1
      this.$emit('tabChange', this.curTab)
    },
    handleMore(index) {
      this.$set(this.showMoreObj, index, true)
    },
    /**
     * 获取评分信息
     * @param {number} score - 评分值
     * @returns {object|null} 评分配置信息
     */
    getScoreInfo(score) {
      return this.scoreObj[score] || null
    },

    /**
     * 格式化日期显示
     * @param {string} dateStr - 日期字符串
     * @returns {string} 格式化后的日期
     */
    formatDate(dateStr) {
      if (!dateStr) return ''

      try {
        // 提取日期部分并替换分隔符
        return dateStr.split(' ')[0].replace(/-/g, '.')
      } catch (error) {
        console.warn('日期格式化失败:', error)
        return dateStr
      }
    },

    /**
     * 处理图片加载错误
     * @param {Event} event - 图片错误事件
     */
    handleImageError(event) {
      // 设置默认头像
      const defaultAvatar = 'https://cdnvue.gymcity.com.cn/uploads/pub-red-logo'
      event.target.src = defaultAvatar
      console.warn('用户头像加载失败，使用默认头像')
    }
  }
}
</script>

<style lang="scss" scoped>
// 视口宽度转换函数
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.DetailEvaluateList {
  width: 100%;
  box-sizing: border-box;
  padding: 0 vw(16);
  margin-top: vw(20);

  // 标题区域样式
  .devl-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .devl-title-left,
    .devl-title-right {
      display: flex;
      align-items: center;
    }

    .devl-title-img {
      width: vw(15);
      margin-top: vw(-1);
    }

    .devl-title-text {
      font-size: vw(13);
      color: rgba($color: #050b27, $alpha: 0.3);
      line-height: vw(18);
      margin: 0 vw(3);
    }
    .devl-title-right {
      .devl-title-text {
        color: rgba($color: #050b27, $alpha: 0.5);
      }
    }
  }

  // 评价列表样式
  .devl-list {
    width: 100%;
    box-sizing: border-box;
    margin-top: vw(14);

    .devl-item {
      width: 100%;
      box-sizing: border-box;

      // 除最后一项外，添加底部边框和间距
      &:not(:last-child) {
        padding-bottom: vw(15);
        margin-bottom: vw(15);
        border-bottom: 1px solid rgba($color: #050b27, $alpha: 0.03);
      }

      // 用户信息区域
      .devl-item-user {
        display: flex;
        align-items: center;
        .user-img-box {
          width: vw(28);
          height: vw(28);
          border-radius: 50%;
          margin-right: vw(8);
          overflow: hidden;
          position: relative;
          .user-img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.1);
            border-radius: 50%;
            backdrop-filter: blur(2px);
            position: absolute;
            top: 0;
            left: 0;
          }
        }

        .user-name {
          font-size: vw(12);
          font-weight: 600;
          color: rgba($color: #050b27, $alpha: 0.8);
          margin-right: vw(4);
        }

        .user-time {
          height: vw(16);
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: vw(10);
          color: rgba($color: #050b27, $alpha: 0.3);
          padding: 0 vw(4);
          border: 1px solid rgba($color: #050b27, $alpha: 0.1);
          border-radius: vw(2);
        }
      }

      // 评价描述区域
      .devl-item-desc {
        display: flex;
        align-items: center;
        font-size: vw(12);
        color: rgba($color: #050b27, $alpha: 0.3);
        line-height: vw(18);
        margin-top: vw(12);

        .desc-left {
          flex: 1;
          display: flex;
          align-items: center;
          overflow: hidden;

          .desc-score {
            display: flex;
            align-items: center;
            margin-right: vw(7);

            .score-img {
              width: vw(13);
              margin-right: vw(3);
              margin-top: vw(-1);
            }

            .score-text {
              // 评分文字样式
            }
          }

          .desc-line {
            width: vw(1);
            height: vw(11);
            background-color: rgba($color: #050b27, $alpha: 0.3);
            margin-right: vw(7);
          }

          .desc-target {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .desc-date {
          margin-left: vw(28);
          text-align: right;
        }
      }

      // 评价内容
      .devl-item-content {
        font-size: vw(14);
        color: rgba($color: #050b27, $alpha: 1);
        line-height: vw(22);
        margin-top: vw(2);
        white-space: pre-line;
        word-break: break-all;
        .cent-btn {
          // margin-top: vw(50);
          color: #4d58a1;
          font-weight: 500;
          /*其他装饰样式*/
        }
      }

      // 标签列表
      .devl-item-tag {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-left: vw(-6);
        overflow-y: hidden;
        max-height: vw(28 * 2); // 最多展示2行

        .tag-item {
          font-size: vw(12);
          color: rgba($color: #050b27, $alpha: 0.5);
          background: rgba($color: #050b27, $alpha: 0.04);
          border-radius: vw(2);
          padding: vw(2) vw(6);
          margin-top: vw(8);
          margin-left: vw(6);
        }
      }
    }
  }
}
</style>
